import { useState } from 'react';
import { useAuth } from 'contexts/AuthContext';
import { Brain, Video, MessageSquare, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const PLUS = [
  { key: 'ai_tutor',    flag: 'ai_assistant', label: 'Tutor IA',            icon: Brain },
  { key: 'avatar_call', flag: 'avatar_call',  label: 'Videollamada avatar', icon: Video },
  { key: 'roleplay',    flag: 'roleplay',     label: 'Juego de rol',        icon: MessageSquare },
];

const OrgPlusFeatures = ({ org, users, onSaved }) => {
  const { api } = useAuth();
  const [saving, setSaving] = useState(null);
  const [state, setState] = useState(() => Object.fromEntries(PLUS.map(f => {
    const acc = org.feature_access?.[f.key] || {};
    return [f.key, {
      enabled: !!org.features?.[f.flag],
      scope: acc.scope || 'all',
      user_ids: acc.user_ids || [],
    }];
  })));

  const patch = (key, p) => setState(s => ({ ...s, [key]: { ...s[key], ...p } }));
  const toggleUser = (key, id) => {
    const ids = state[key].user_ids;
    patch(key, { user_ids: ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id] });
  };

  const save = async (key) => {
    setSaving(key);
    try {
      await api.put(`/superadmin/organizations/${org.id}/features/${key}`, state[key]);
      toast.success('Guardado');
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al guardar');
    } finally { setSaving(null); }
  };

  return (
    <div className="space-y-4">
      {PLUS.map(({ key, label, icon: Icon }) => {
        const s = state[key];
        return (
          <div key={key} className="p-4 bg-white/5 border border-white/10 rounded-xl space-y-3">
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2 text-[12px] font-black uppercase tracking-widest text-white">
                <Icon className="w-4 h-4" /> {label}
              </span>
              <input type="checkbox" checked={s.enabled}
                onChange={e => patch(key, { enabled: e.target.checked })} />
            </div>

            {s.enabled && (
              <>
                <div className="flex gap-2">
                  {[['all', 'Todos'], ['selected', 'Usuarios concretos']].map(([v, l]) => (
                    <button key={v} onClick={() => patch(key, { scope: v })}
                      className={`px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-widest border ${
                        s.scope === v ? 'border-[#00FFFF] text-[#00FFFF] bg-[#00FFFF]/10'
                                      : 'border-white/10 text-white/50'}`}>
                      {l}
                    </button>
                  ))}
                </div>

                {s.scope === 'selected' && (
                  <div className="max-h-48 overflow-y-auto border border-white/10 rounded-xl p-2 bg-black/40">
                    {users.map(u => (
                      <label key={u.id} className="flex items-center gap-3 p-2 hover:bg-white/5 rounded-lg cursor-pointer">
                        <input type="checkbox" checked={s.user_ids.includes(u.id)}
                          onChange={() => toggleUser(key, u.id)} />
                        <span className="text-[13px] text-white">{u.name}</span>
                      </label>
                    ))}
                  </div>
                )}
              </>
            )}

            <button onClick={() => save(key)} disabled={saving === key}
              className="btn-neon-lime px-5 py-2 rounded-xl text-[11px] font-black uppercase tracking-widest flex items-center gap-2">
              {saving === key && <Loader2 className="w-4 h-4 animate-spin" />} Guardar
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default OrgPlusFeatures;